var icons = {
    paperlessIcon: "/paperlessIcon.svg",
    noStatementIcon: "/NoStatementsIconWithCat.svg",
    errorIcon: "/ErrorIcon.svg",
    statementsDownIcon: "/StatementsDownIcon.svg",
};
export default icons;
